export function countBy<T>(
	array: T[],
	iteratee: (item: T) => string | number,
): Record<string, number> {
	return array.reduce(
		(acc, item) => {
			const key = iteratee(item);
			acc[key] = (acc[key] || 0) + 1;
			return acc;
		},
		{} as Record<string, number>,
	);
}
